import { ReactNode } from 'react';

import UImage from '../../../../components/UImage';
import { Diary } from '../../../../type/recipe';
import { MAX_WIDTH_639PX } from '../../../../utils/common';
import useClientMediaQuery from '../../../../utils/hook/useClientMediaQuery';

interface RecipeMainDiaryThumbnailProps {
  diary: Diary;
  onClick: () => void;
  index: number;
}
const RecipeMainDiaryThumbnail = ({
  diary,
  onClick,
  index,
}: RecipeMainDiaryThumbnailProps) => {
  const isMobile = useClientMediaQuery({ query: MAX_WIDTH_639PX });

  // 모바일이면서 첫번째 엘리먼트만 GradientStrokeSpin 적용
  const WrapperComponent =
    isMobile && index === 0
      ? GradientStrokeSpin
      : ({ children }: { children: ReactNode }) => <>{children}</>;

  return (
    <button
      onClick={onClick}
      className={`relative overflow-hidden rounded-10px ${
        index === 0 && 'col-span-2 row-span-2'
      }`}
      type="button"
    >
      <WrapperComponent>
        <UImage
          src={diary.thumbnail || diary.photos[0]}
          alt={`${diary.writer.name}님의 집밥일기`}
          width={400}
          height={400}
          className="aspect-[1/1] object-cover object-center"
        />
      </WrapperComponent>
      <div
        className="absolute inset-0 flex items-end justify-center p-12px"
        style={{
          background: `linear-gradient(0deg, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0.00) 36.11%)`,
        }}
      >
        <p className="text-center text-14px font-medium text-white line-clamp-1">
          {diary.writer.name}
        </p>
      </div>
    </button>
  );
};

export default RecipeMainDiaryThumbnail;

const GradientStrokeSpin = ({ children }: { children: ReactNode }) => {
  return (
    <>
      <div className="absolute -top-1/4 -left-1/4 z-[1] h-[150%] w-[150%] animate-spin bg-gradient-to-r from-transparent via-white to-brand-1" />
      <div className="absolute inset-[4px] z-[2] h-[calc(100%-8px)] w-[calc(100%-8px)] overflow-hidden rounded-[6px]">
        {children}
      </div>
      <svg
        className="animate-blink absolute left-12px top-12px"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <circle cx="12" cy="12" r="12" fill="#FF6741" />
        <path
          d="M6.5455 17.4545V6.54541H9.6127L15.2412 13.1844H13.8182V6.54541H17.4546V17.4545H14.3874L8.75894 10.8155H10.1819V17.4545H6.5455Z"
          fill="white"
        />
      </svg>
    </>
  );
};
